import registerLink from '../../../common/links/index';
import presentationalComponent from './Link';
import containerComponent from './LinkContainer';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';
import { allSelectedElementsDisplayingInfo } from '../../workspace/toolbar/config/toolbarToolConfigUtils';
import { labelsFeaturePredicate } from '../labels/labelsUtils';

const allDisplayingInfo = ({ selectedElements }) => allSelectedElementsDisplayingInfo(selectedElements);

const LINK_SELECTED_TOOLS = [
    TOOLBAR_TOOLS.COLOR,
    { ...TOOLBAR_TOOLS.MEDIA, availabilityPredicate: allDisplayingInfo },
    TOOLBAR_TOOLS.DISPLAY_INFO,
    { ...TOOLBAR_TOOLS.CAPTION, availabilityPredicate: allDisplayingInfo },
    TOOLBAR_TOOLS.REACTION,
    { ...TOOLBAR_TOOLS.LABEL, availabilityPredicate: labelsFeaturePredicate },
    TOOLBAR_TOOLS.COMMENT,
    ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
];

export default () =>
    registerLink({
        containerComponent,
        presentationalComponent,
        tools: {
            selected: LINK_SELECTED_TOOLS,
            editing_TITLE: LINK_SELECTED_TOOLS, // use regular selection tools when editing title
            editing_CAPTION: TOOL_SETS.TEXT_EDITING_CAPTION,
        },
    });
